import React, { FC, useState, useEffect, useContext } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Text from "../Text"
import Box from "../Box"

// ** Icons
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import PageContext from "../../contexts/PageContext"

interface Props {
  title: string
}
const PostAside: FC<Props> = ({ title }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityPage(filter: { title: { eq: "Post-page" } }) {
        nodes {
          slug {
            current
          }
          i18n_lang
          sections {
            ... on SanitySectionList {
              label
              listType
              title
              listItems {
                Label
                title
                value
                Image {
                  asset {
                    gatsbyImageData(
                      width: 30
                      formats: [WEBP, AUTO]
                      layout: FIXED
                      placeholder: NONE
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  const page = useContext(PageContext);

  let interestTitle = ""
  let recentTitle = ""
  let interestList: any[] = []
  let recentList: any[] = []
  let socialList: any[] = []
  const [body, setBody] = useState("")
  const [isMounted, setIsMounted] = useState(false)
  data?.allSanityPage?.nodes?.map((node: any) => {
    if (node.i18n_lang === page.i18n_lang) {
      node.sections.map((section: any) => {
        if (
          section.label === "Browse Topic by Interest (List)" ||
          section.label === "Browse Topic by Interest (fr) (list)"
        ) {
          interestTitle = section.title
          interestList = section.listItems
        } else if (
          section.label === "Recent Posts at 8Twelve (List)" ||
          section.label === "Recent Posts at 8Twelve (fr) (list)"
        ) {
          recentTitle = section.title
          recentList = section.listItems
        } else if (section.label === "FAQ - Social Media Icons") {
          socialList = section.listItems
        }
      })
    }
  })
  useEffect(() => {
    if (isMounted) setBody(window?.location?.href)
  }, [isMounted])
  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <Box className="basis-3/12 px-4 py-8 bg-gray-50 rounded-[11px] mt-10 md:mt-14">
      <Box>
        <Text variant="body-copy" className="text-blue-500 font-extrabold mb-3">
          {interestTitle}
        </Text>
        <ul>
          {interestList &&
            interestList.map((interest: any, index: number) => (
              <li key={"interest" + index}>
                <Link to={`${interest.value}`} className="cursor-pointer">
                  <Text
                    variant="body-copy"
                    className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                  >
                    {interest.title}
                  </Text>
                </Link>
              </li>
            ))}
        </ul>
      </Box>
      <Box className="mt-10">
        <Text variant="body-copy" className="text-blue-500 font-extrabold mb-3">
          {recentTitle}
        </Text>
        <ul>
          {recentList &&
            recentList.map((recent: any, index: number) => (
              <li key={"recent" + index}>
                <Link to={`${recent.value}`} className="cursor-pointer">
                  <Text
                    variant="body-copy"
                    className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                  >
                    {recent.title}
                  </Text>
                </Link>
              </li>
            ))}
        </ul>

        <Box className="hidden gap-x-4 mt-10 sm:flex">
          {socialList &&
            socialList.map((social: any, index: number) => (
              <a
                key={"social" + index}
                href={
                  social.title === "email"
                    ? `mailto:?subject=${"Fw: " + title}&body=${body}`
                    : `${social.value}`
                }
                className="w-[30px] h-[30px]"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GatsbyImage
                  image={social.Image.asset.gatsbyImageData as IGatsbyImageData}
                  alt={social.title || "social"}
                />
              </a>
            ))}
        </Box>
      </Box>
    </Box>
  )
}

export default PostAside
